import { useDroppable, type UniqueIdentifier } from '@dnd-kit/core';
import { Box, styled } from '@mui/material';
import { type PropsWithChildren } from 'react';

const PREFIX = 'TSMED-LayoutBuilder-Droppable';

const droppableClasses = {
  root: `${PREFIX}-root`,
};

const Root = styled(Box)({
  [`&.${droppableClasses.root}`]: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'stretch',
    position: 'relative',
  },
});

export const Droppable = ({
  id,
  children,
  onClick,
  disabled,
}: PropsWithChildren<{
  id: UniqueIdentifier;
  onClick?: (e: React.MouseEvent) => void;
  disabled?: boolean;
}>) => {
  const { setNodeRef } = useDroppable({
    id,
    disabled,
  });

  return (
    <Root className={droppableClasses.root} ref={setNodeRef} onClick={onClick}>
      {children}
    </Root>
  );
};
